import LegalDocLayout, {
  LegalSection,
} from "@/components/LegalDocLayout";

export default function Terms() {
  return (
    <LegalDocLayout
      testid="legal-doc-page-terms"
      title="Terms of Service"
      effectiveDate="[PLACEHOLDER — to be filled by legal counsel]"
      lastUpdated="[PLACEHOLDER]"
    >
      <LegalSection heading="1. Acceptance of Terms">
        By creating an account or otherwise accessing FiguMatch (the
        &ldquo;Service&rdquo;), you agree to be bound by these Terms of
        Service. If you do not agree, you must not use the Service. These
        Terms may reference additional guidelines that are hereby
        incorporated by reference.
      </LegalSection>

      <LegalSection heading="2. Description of Service">
        FiguMatch is a peer-to-peer platform for collectors of soccer
        stickers and related collectibles. The Service enables you to
        register your duplicate and missing stickers, discover nearby
        collectors, coordinate in-person trades, and earn in-app rewards.
        Features and availability may evolve over time.
      </LegalSection>

      <LegalSection heading="3. User Accounts and Registration">
        You must provide accurate, current, and complete information when
        creating an account and keep it updated. You are responsible for
        safeguarding your credentials and for any activity that occurs
        under your account. Accounts are personal and may not be
        transferred or shared without our express written consent.
      </LegalSection>

      <LegalSection heading="4. Acceptable Use">
        You agree to use the Service only for lawful purposes and in
        accordance with these Terms. You will not harass other users,
        misrepresent your identity, submit fraudulent or misleading
        listings, attempt to circumvent security measures, or use the
        Service to engage in any activity that could harm the platform or
        its community.
      </LegalSection>

      <LegalSection heading="5. User-Generated Content">
        You retain ownership of the content you submit to FiguMatch,
        including your inventory data, messages, display name, and
        location. By submitting content, you grant us a worldwide,
        non-exclusive, royalty-free license to host, store, reproduce,
        and display such content solely to operate and improve the
        Service.
      </LegalSection>

      <LegalSection heading="6. FiguTokens and Rewards">
        FiguTokens are a virtual, non-monetary utility used within
        FiguMatch to unlock in-app features and rewards. FiguTokens have
        no cash value, cannot be redeemed for currency, and may not be
        transferred outside of the Service. We reserve the right to
        adjust the earning rate, redemption options, and lifetime of
        FiguTokens.
      </LegalSection>

      <LegalSection heading="7. Intellectual Property">
        All trademarks, logos, brand names, page designs, and original
        software associated with FiguMatch are the property of the
        Service provider or its licensors. Nothing in these Terms grants
        you a license to use any of the foregoing outside of your
        ordinary use of the Service.
      </LegalSection>

      <LegalSection heading="8. Third-Party Services">
        The Service may integrate with third-party services (for example
        payment providers, mapping providers, and AI concierge providers).
        Your use of such third-party services is governed by their
        respective terms and privacy policies. We are not responsible for
        the acts or omissions of any third party.
      </LegalSection>

      <LegalSection heading="9. Termination">
        We may suspend or terminate your access to the Service at any
        time, with or without notice, if we believe you have violated
        these Terms, engaged in fraud, or otherwise put the community at
        risk. You may terminate your account at any time by contacting
        us.
      </LegalSection>

      <LegalSection heading="10. Disclaimers and Limitation of Liability">
        The Service is provided on an &ldquo;as is&rdquo; and &ldquo;as
        available&rdquo; basis without warranties of any kind. To the
        maximum extent permitted by law, we disclaim all warranties,
        express or implied. In no event will we be liable for indirect,
        incidental, or consequential damages arising from your use of the
        Service.
      </LegalSection>

      <LegalSection heading="11. Governing Law">
        These Terms are governed by and construed in accordance with the
        laws of the jurisdiction specified by the Service provider,
        without regard to conflict-of-law principles. Any disputes shall
        be resolved in the competent courts of that jurisdiction.
      </LegalSection>

      <LegalSection heading="12. Changes to These Terms">
        We may update these Terms from time to time. When we make
        material changes, we will notify you through the Service or by
        email. Continued use of the Service after the effective date of
        the updated Terms constitutes your acceptance of the changes.
      </LegalSection>

      <LegalSection heading="13. Contact">
        If you have questions or concerns about these Terms, please
        reach out to us at hello@figumatch.com. We aim to respond to
        every inquiry within a reasonable time.
      </LegalSection>
    </LegalDocLayout>
  );
}
